import React from "react";
import Dashboard from "../components/Dashboard/Dashboard.jsx";

const DashboardPage = () => {
  return (
    <div>
      <Dashboard />
    </div>
  );
};

export default DashboardPage;
